import React, { useEffect, useRef, useState } from 'react';

// Card image that self-corrects its display mode: photos fill the frame
// (object-cover), but portrait posters, ultra-wide banners, low-res crops and
// logo-type images switch to object-contain over a blurred backdrop so nothing
// is stretched, pixelated or brutally cropped.
export default function SmartImage({ src, alt = '', fallback = '', hoverZoom = false, className = '' }) {
  const [url, setUrl] = useState(src);
  const [fit, setFit] = useState('cover');
  const imgRef = useRef(null);

  function evaluate(img) {
    const w = img.naturalWidth;
    const h = img.naturalHeight;
    if (!w || !h) return;
    const logoish = /logo/i.test(img.currentSrc || url || '');
    // contain when: low-res, portrait poster, ultra-wide banner, or logo
    if (w < 480 || h > w * 1.15 || w > h * 2.05 || logoish) setFit('contain');
  }

  useEffect(() => { setUrl(src); setFit('cover'); }, [src]);

  // Cached images can finish loading before React attaches onLoad — re-check.
  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete && img.naturalWidth) evaluate(img);
  }, [url]);

  function onError() {
    if (fallback && url !== fallback) { setUrl(fallback); setFit('cover'); }
  }

  return (
    <div className="relative w-full h-full bg-stone overflow-hidden">
      {fit === 'contain' && (
        <img src={url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-50" />
      )}
      <img
        ref={imgRef}
        src={url}
        alt={alt}
        loading="lazy"
        onLoad={(e) => evaluate(e.currentTarget)}
        onError={onError}
        data-img-fit={fit}
        className={`relative w-full h-full ${fit === 'cover'
          ? `object-cover ${hoverZoom ? 'transition-transform duration-700 group-hover:scale-105' : ''}`
          : 'object-contain'} ${className}`}
      />
    </div>
  );
}
